export default [
    {
        id: 1,
        code_bde: 'L',
        name_ca: 'Lliure',
        name_es: 'Libre',
        name_en: 'Free'
    }, {
        id: 2,
        code_bde: 'A',
        name_ca: 'En lloguer o sota altre títol legal',
        name_es: 'En alquiler o bajo otro título legal',
        name_en: 'Rented or under any other legal title'
    }, {
        id: 3,
        code_bde: 'O',
        name_ca: 'Ocupat sense títol',
        name_es: 'Ocupado sin título',
        name_en: 'Occupied without title'
    }, {
        id: 4,
        code_bde: 'Z',
        name_ca: 'No aplicable',
        name_es: 'No aplicable',
        name_en: 'Not applicable'
    }
]



// WEBPACK FOOTER //
// ./src/options/occupancy_statuses.js